import './en'
import './de'
import './es'
import './fr'
import './ko'
import './ar'
import './pt'
import frLocale from './angular-locale_fr'
import deLocale from './angular-locale_de'
import esLocale from './angular-locale_es'
import koLocale from './angular-locale_ko'
import nbLocale from './angular-locale_nb'
import nnLocale from './angular-locale_nn'
import noLocale from './angular-locale_no'
import svLocale from './angular-locale_sv'
import en_NZLocale from './angular-locale_en-nz'
import arLocale from './angular-locale_ar'
import ptLocale from './angular-locale_pt'

const angularLocales = {
  frLocale,
  deLocale,
  esLocale,
  koLocale,
  nbLocale,
  nnLocale,
  noLocale,
  svLocale,
  en_NZLocale,
  arLocale,
  ptLocale,
}

export default function initAngularLocale(currentLocale) {
  // Extract 2 byte ISO 639-1 code
  const region = (currentLocale || '').slice(0, 2)
  const initFnName = `${region}Locale`
  angularLocales[initFnName] && angularLocales[initFnName]()
}
